export default "__VITE_ASSET__D0FEvfKf__"